import styled from 'styled-components';

const PageContainer = styled.div`
  background-color: var(--gray-lighter);
  display: flex;
  flex-direction: column;
  color: var(--gray-darkest);
  padding: 20px;
  box-sizing: border-box;
  gap: 24px;
`;

export default PageContainer;
